export default __webpack_public_path__ + "static/media/coins-solid.c52e6e68.svg";